import React from "react";

const InputHeader = ({ title, className, onClick }) => {
  return (
      <p onClick={onClick} className={className}>
        {title} <span style={{color: "red"}}>*</span>
      </p>
  );
};

export default InputHeader;
